import { api } from '../api';

import type { ReviewTemplate } from '@/types/review/ReviewTemplate';

export default {
    async importAmelioTemplate(templateId: string): Promise<ReviewTemplate> {
        const response = await api.post(`/reviewtemplate/importtemplate`, {
            templateId,
        });

        return response.data;
    },
};
